module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAV1BMVEUAAABicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZnHLpMEAAAAHHRSTlMABdtU+argiVsP8eSszHdEv7emZj+blJN9SjMiuJqYGwAAAKhJREFUKM+dUUkSwyAMM2uAQMjSvf7/Ozs1HkJJT9HJsrBABk5DqNXqIFclfvtKIkOq9viADYZ9qPR3pfpgB8VGIzHzAsiJyrGYOSIL1b48whExVGfIKN8wEYkkWKq3KX3NNyKWBI01g+dxTUJAhgF2YqGG9jWQ5csLEnhkRH7uAY4D1isCtgFh7gVeyaWw4xLnrn8TdUAvjz8fdb0/PYBw0WptoxNwFh/ZrB0ZuF5bkgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_faq.png
// module id = wbq/
// module chunks = 9